// React
import React from "react";
import FlexContainer from "common/ui/containers/flexContainer/FlexContainer";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./CardPanel.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class CardPanel extends React.Component {
    render() {
        const { title } = this.props;
        return (React.createElement(FlexContainer, { className: styles.cardPanel },
            React.createElement("div", { className: styles.cardPanelHeading },
                React.createElement("h3", { style: { color: this.props.titleColour } }, title)),
            this.props.children));
    }
}
